//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";


const IPStrategy: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="IP Experts and Strategies" />

            <SubSection isSplit={false}>
                <div className="description-container">
                    <b>IP Actions & Protections with Intellectual Property Insurance Services Corp. (IPISC)</b>
                    <p>

                        1,500+ pages of patents with over 390 claims have been filed, and
                        with 100% of the first 60, that were adjudicated have been granted.
                        Our engine comparing and product tracking software will aid in IP license
                        and ELF-Tech use tracking. We will use IPISC, founded by Robert W. Fletcher,
                        Esq., CHE, MBA, patent attorney, with Lloyds of London as their reinsurer,
                        to insure us for IP defense, IP enforcement, multi-peril, and unauthorized
                        confidential disclosure.
                    </p>{" "}
                </div>
            </SubSection>
        </div>
    );
};

export default IPStrategy;